import {store_getStateValue_vo, store_var} from "../store";
import {gv_numbers} from "../../functions/src/shareCode/Share_Ass_GlobalVariable";
import {format_changeUnit} from "../../functions/src/shareCode/Share_S_Format";
import {enum_timeUnits} from "../../functions/src/shareCode/Share_S_Enum";

let timeoutCb_byId = {}
let intervalsById = {}
let doEveryCbs_byId_f = {}

// date_getToday0am_d
export const date_getToday0am_d = () =>{
    let now_d = date_newDate_fd()

    now_d.setHours(0)
    now_d.setMinutes(0)
    now_d.setSeconds(0)
    now_d.setMilliseconds(0)

    return now_d
}

// date_firstDayOfTheMonth_t
export const date_getFirstDayOfMonth_t = () =>{
    let now_d = date_newDate_fd()

    now_d.setDate(1)
    now_d.setHours(0)
    now_d.setMinutes(0)
    now_d.setSeconds(0)
    now_d.setMilliseconds(0)

    return now_d.getTime()
}

// date_monthDiff_fn
export const date_monthDiff_fn = (d1, d2) => {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

// date_sameYear_fb
export const date_newDate_withDayAndHour_ft = (dayOfTheWeek_n, hours) => {

    let ans_d = date_getNowDate_resetSeconds_fd()

    while(ans_d.getDay() !== dayOfTheWeek_n){
        ans_d.setDate(ans_d.getDate() + 1)
    }

    ans_d.setHours(hours)
    ans_d.setMinutes(0)

    return ans_d.getTime()
}
export const date_sameYear_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getFullYear() === date_newDate_fd(timestamp2_t).getFullYear()
}

// date_sameMonth_fb
export const date_sameMonth_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getMonth() === date_newDate_fd(timestamp2_t).getMonth()
}

// date_sameDayMonth_fb
export const date_sameDayMonth_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getDate() === date_newDate_fd(timestamp2_t).getDate()
}

// date_sameDay_fb
export const date_sameDayWeek_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getDay() === date_newDate_fd(timestamp2_t).getDay()
}

// date_sameHour_fb
export const date_sameHour_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getHours() === date_newDate_fd(timestamp2_t).getHours()
}

// date_sameMinutes_fb
export const date_sameMinutes_fb = (timestamp1_t, timestamp2_t) => {
    return date_newDate_fd(timestamp1_t).getMinutes() === date_newDate_fd(timestamp2_t).getMinutes()
}

// date_sameDay
export const date_sameDay_fb = (d1_d, d2_d) => {

    if(d1_d == null || d2_d == null)
        return false

    return d1_d.getFullYear() === d2_d.getFullYear()
        && d1_d.getMonth()    === d2_d.getMonth()
        && d1_d.getDate()     === d2_d.getDate();
}

// date_addMinutesToDateTime
export const date_addMinutesToDateTime_ft = (dateTime, minutesToAdd) => {
    let endingDate = date_newDate_fd(dateTime);

    endingDate.setMinutes(endingDate.getMinutes() + parseInt(minutesToAdd))

    return endingDate.getTime()
}

// date_getDurationToEndGame_seconds
export const date_getDurationToEndEvent_seconds = (startingDateTime, duration_minutes) => {

    if(!startingDateTime || !duration_minutes)
        return -1;

    let endingDateTime = date_addMinutesToDateTime_ft(startingDateTime, duration_minutes);
    let nowTime = date_newDate_fd().getTime()

    return (endingDateTime - nowTime) / gv_numbers.millisecondsInSecond

}

// date_getDurationToStartEvent_seconds
export const date_getDurationToStartEvent_seconds = (startingDateTime) =>{

    if(!startingDateTime){
        return -1
    }

    let nowTime = date_newDate_fd().getTime()
    return (startingDateTime - nowTime) / gv_numbers.millisecondsInSecond

}

// ============= timeout interval and clock tick

// date_getNowDate_resetSeconds_fd
export const date_getNowDate_resetSeconds_fd = () =>{
    let date_d = date_newDate_fd()

    date_d.setSeconds(0)
    date_d.setMilliseconds(0)

    return date_d
}

// date_daysInMonth_f
export const date_daysInMonth_f = (date_d) => {
    return new Date(date_d.getFullYear(), date_d.getMonth(), 0).getDate();
}

// date_newDate_fd
export const date_newDate_fd = (time_t=null) =>{
    if(time_t){
        return new Date(time_t)
    }
    let serverTimeOffset_vn = store_getStateValue_vo(store_var.system_serverTimeOffset_n)
    return new Date((new Date()).getTime() + serverTimeOffset_vn.val)
}

// date_setTimeout
const timeout_byName_o = {}
export const date_setTimeout = (cb_f, milliseconds_n, name_s) => {

    if(timeout_byName_o[name_s] != null){
        date_clearTimeout(name_s)
    }

    timeout_byName_o[name_s] = setTimeout(cb_f, milliseconds_n)

}
export const date_clearTimeout = (name_s) => {

    if(timeout_byName_o[name_s]){
        clearTimeout(timeout_byName_o[name_s]);
    }
}

// date_setInterval
export const date_setInterval = (id, millscn, stopAfter_millscn, doEveryInterval, doLast) => {

    if(stopAfter_millscn === 0){
        return
    }

    // remove old intervals
    if (intervalsById[id]) {
        clearInterval(intervalsById[id])
    }

    // init
    let counter = 0;
    if (doEveryInterval) doEveryInterval()

    // start interval
    let interval = setInterval(() => {
        counter += millscn;

        if (stopAfter_millscn && counter >= stopAfter_millscn) {
            clearInterval(interval);
            intervalsById[id] = null
            if (doLast) doLast()
        } else {
            if (doEveryInterval) doEveryInterval()
        }
    }, millscn);

    // save current interval
    intervalsById[id] = interval

}
export const date_removeInterval = (id) => {
    clearInterval(intervalsById[id]);
    intervalsById[id] = null
}

// doEvery_init_f
export const doEvery_init_f = (id, millscn, doEveryCb_f) => {


    if(doEveryCbs_byId_f[id] != null){
        doEveryCbs_byId_f[id] = doEveryCb_f
        return
    }

    doEveryCbs_byId_f[id] = doEveryCb_f
    let timeoutFunc = () => {

        if(doEveryCbs_byId_f[id] != null){
            doEveryCbs_byId_f[id]()
            setTimeout(timeoutFunc, millscn);
        }
    };

    timeoutFunc()
}
export const doEvery_stop_f = (id) => {
    doEveryCbs_byId_f[id] = null
}

// clock tick
export const date_doEveryClockTick_init_f     = (updateStoreClock_cb) => {

    // singleton
    if(timeoutCb_byId[store_var.system_clock_dateTime]){
        console.log('already init clock')
        return;
    }
    timeoutCb_byId[store_var.system_clock_dateTime] = updateStoreClock_cb

    let timeoutFunc = () => {

        for(let key in timeoutCb_byId){
            timeoutCb_byId[key]()
        }

        setTimeout(timeoutFunc,gv_numbers.millisecondsInSecond);
    };

    timeoutFunc()
}
export const date_doEveryClockTick_addCb_f    = (id_s, cb_f, firstCall_b) => {

    if(cb_f == null){
        console.log(id_s + ' null function')
        return
    }

    // singleton
    if(timeoutCb_byId[id_s]){
        console.log(id_s + ' already init clock')
    }


    timeoutCb_byId[id_s] = cb_f

    if(firstCall_b){cb_f()}

}
export const date_doEveryClockTick_removeCb_f = (id) => {
    delete timeoutCb_byId[id]
}

// date_pastXDays_fb
export const date_pastXDays_fb = (timestamp_t, days_n) => {

    let now_d = date_newDate_fd()
    now_d.setDate(now_d.getDate() - days_n)
    return now_d.getTime() > timestamp_t
}

// date_pastXHours_fb
export const date_pastXHours_fb = (timestamp_t, hours_n) => {
    let now = date_newDate_fd()
    now.setHours(now.getHours() - hours_n)
    return now.getTime() > timestamp_t
}

// date_pastXHours_fb
export const date_pastXSecond_fb = (timestamp_t, seconds_n) => {
    let now_t = date_newDate_fd().getTime()

    return (now_t - timestamp_t) / gv_numbers.millisecondsInSecond > seconds_n
} // date_getTimePastInSeconds_fn

// date_getTimePastInSeconds_fn
export const date_getTimePastInSeconds_fn = (timestamp_t) => {
    let now_t = date_newDate_fd().getTime()

    return format_changeUnit(now_t - timestamp_t, enum_timeUnits.milliseconds, enum_timeUnits.seconds)
}

// date_doOnlyOnce_fn
const timeoutIds_byId_s = {}
export const date_doOnlyOnce_fn = (id_s, cb_f) => {
    clearTimeout(timeoutIds_byId_s[id_s])
    timeoutIds_byId_s[id_s] = setTimeout(cb_f)
}